import '../index.css';
var styles = {
  "toolbarRoot": "bp_toolbar_module_toolbarRoot--f2e15",
  "scrollButtonWrapper": "bp_toolbar_module_scrollButtonWrapper--f2e15",
  "hidden": "bp_toolbar_module_hidden--f2e15",
  "scrollableChildrenWrapper": "bp_toolbar_module_scrollableChildrenWrapper--f2e15",
  "separator": "bp_toolbar_module_separator--f2e15",
  "toggleGroup": "bp_toolbar_module_toggleGroup--f2e15",
  "toolbarItem": "bp_toolbar_module_toolbarItem--f2e15",
  "toolbarToggle": "bp_toolbar_module_toolbarToggle--f2e15",
  "dropdownIndicator": "bp_toolbar_module_dropdownIndicator--f2e15",
  "invertCaret": "bp_toolbar_module_invertCaret--f2e15",
  "triggerButtonSelectedWithColor": "bp_toolbar_module_triggerButtonSelectedWithColor--f2e15",
  "toolbarIcon": "bp_toolbar_module_toolbarIcon--f2e15",
  "toolbarTextToggleItem": "bp_toolbar_module_toolbarTextToggleItem--f2e15"
};
export { styles as default };